<cerrix-loader [cerrixTab]="tab" [showLoader]="!finishedLoading"></cerrix-loader>

@if (finishedLoading && detailsModel) {
    <div>
        @if (!hideActionBar) {
            <div class="detail-page-action-bar flex-action-bar">
                <div>
                    <button class="btn btn-cerrix" [disabled]="!saveAllowed" (click)="save()">
                        <i class="fas fa-save"></i>
                        <span data-uiid="fr-assessment-save" class="d-none d-lg-inline">{{ 'assessment.saveBtn' | transloco }}</span>
                    </button>

                    @if (detailsModel.modifiedAt) {
                        <span class="date-edited">
                            {{ 'assessment.lastSave' | transloco: { modifiedAt: (detailsModel.modifiedAt | dateTimeFormat) } }}
                        </span>
                    }
                </div>
            </div>
        }

        <div menuSystem [cerrixTab]="tab" class="assessment" (changeEvent)="onMenuItemClick($event)">
            <div menuItemId="menuItemAssessment" [attr.name]="'assessment.menuAssessment' | transloco" menuicon="fas fa-poll-people" menusystemsubmenu>
                <div
                    menuItemId="details"
                    [attr.name]="'assessment.menuDetails' | transloco"
                    menusystemitem
                    menuicon="fas fa-info-circle"
                >
                    <assessment-details-main
                        [formGroup]="formGroup"
                        [detailsModel]="detailsModel"
                        [editAllowed]="saveAllowed"
                    >
                    </assessment-details-main>
                </div>
                @if (detailsModel.guid) {
                    <div menuItemId="menuItemLinks" [attr.name]="'assessment.menuLinks' | transloco" menusystemsubmenu menuicon="fas fa-link">
                        <div
                            menuItemId="mois"
                            [attr.name]="'assessment.menuMeasureOfImprovements' | transloco"
                            menusystemitem
                            menuicon="fas fa-tasks"
                        >
                            <linked-moi-overview
                                [moiType]="moiType"
                                [parentGuid]="detailsModel.findingReportGuid"
                                [assessmentGuid]="detailsModel.guid"
                                [canAdd]="permissionsModel.canAddMoi"
                                [canDelete]="permissionsModel.canDeleteMoi"
                                [useLazyLoading]="false"
                            >
                            </linked-moi-overview>
                        </div>
                    </div>
                    <div
                        menuItemId="history"
                        [attr.name]="'assessment.menuHistory' | transloco"
                        menusystemitem
                        menuicon="fas fa-history"
                    >
                        <app-history-overview
                            [historyDataService]="assessmentService"
                            [Id]="detailsModel.guid"
                            #historyOverviewComponent
                        >
                        </app-history-overview>
                    </div>
                }
            </div>
        </div>
    </div>
}
